import { Injectable } from '@angular/core';
import { SalesfunnelCoveragesItem } from '@app/core/interfaces';
import { CoverageControl } from '@app/my-zone/shared/insurance-coverage/insurance-coverage-control';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CompareTableControlService {
    private readonly selectedCoverageSubject$: Subject<Partial<SalesfunnelCoveragesItem>> = new BehaviorSubject(null);
    public readonly selectedCoverage$ = this.selectedCoverageSubject$.asObservable();
    private readonly selectedCoverageIdSubject$: Subject<string> = new BehaviorSubject(null);
    public readonly selectedCoverageId$ = this.selectedCoverageIdSubject$.asObservable();
    private readonly coverageSubject$: Subject<CoverageControl> = new Subject<CoverageControl>();
    public readonly coverage$ = this.coverageSubject$.asObservable();

    public setSelectedCoverage(coverage: Partial<SalesfunnelCoveragesItem>): void {
        this.selectedCoverageSubject$.next(coverage);
    }

    public setSelectedCoverageId(coverageId: string): void {
        this.selectedCoverageIdSubject$.next(coverageId);
    }

    public setCoverage(coverage: CoverageControl): void {
        this.coverageSubject$.next(coverage);
    }
}
